import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    .layout-modal {
        .modal-container-wrapper {
            width: auto;
            .modal-container {
                .modal-body {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .panel-form-user-login {
                        padding: 0;
                        box-shadow: none;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .layout-modal {
            .modal-container-wrapper {
                width: 90%;
            }
        }
    }
`;
